export enum IncomeSourceType {
  DEPOSIT = 'DEPOSIT',
}
